import type { FC } from "react";

import { cn } from "@/utils/common/styleHelper/utils";

import SkeletonExperienceAutoCompleteComponent from "./SkeletonExperienceAutoCompleteComponent copy";
import SkeletonExperienceSubmitButtonComponent from "./SkeletonExperienceSubmitButtonComponent";

interface Props {
  className?: string;
}

const SkeletonExperienceSearchPanelComponent: FC<Props> = ({
  className = "",
}) => {
  return (
    <div
      className={cn(
        "flex w-full items-center justify-start gap-4 rounded-lg bg-white px-0 shadow-search-mobile outline-0 outline-stone-100 md:w-full md:rounded-2xl md:p-6 md:shadow-search md:outline-4 xl:max-w-7xl",
        className,
      )}
    >
      <SkeletonExperienceAutoCompleteComponent />
      <SkeletonExperienceSubmitButtonComponent />
    </div>
  );
};

export default SkeletonExperienceSearchPanelComponent;
